import { useWeb3Modal } from '@web3modal/wagmi/react'

import { logError } from 'utils/logger'

export const useWeb3ModalHook = () => {
  const { open } = useWeb3Modal()

  const handleConnect = async () => {
    try {
      await open()
    } catch (error) {
      logError('Failed to connect wallet:', error)
    }
  }

  return {
    handleConnect,
  }
}
